// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-outline-primary {
    border: 1px solid #dbc700;
    color: black;
    background: transparent;
}

.btn-outline-primary:hover,
.btn-outline-primary:active {
    background: #dbc700;
    color: white;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

label {
    font-weight: bold;
}

.close {
}


.require-label:after {
    content: ' *';
    color: red;
}

.content-header {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 27px;
    padding: 19px 0px 14px 0px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyZWF0ZS10ZWFtLWRpYWxvZy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0kseUJBQXlCO0lBQ3pCLFlBQVk7SUFDWix1QkFBdUI7QUFDM0I7O0FBRUE7O0lBRUksbUJBQW1CO0lBQ25CLFlBQVk7QUFDaEI7O0FBRUE7SUFDSSxhQUFhO0lBQ2IsbUJBQW1CO0lBQ25CLDhCQUE4QjtBQUNsQzs7QUFFQTtJQUNJLGlCQUFpQjtBQUNyQjs7QUFFQTtBQUNBOzs7QUFHQTtJQUNJLGFBQWE7SUFDYixVQUFVO0FBQ2Q7O0FBRUE7SUFDSSxrQkFBa0I7SUFDbEIsZ0JBQWdCO0lBQ2hCLGlCQUFpQjtJQUNqQixpQkFBaUI7SUFDakIsMEJBQTBCO0FBQzlCIiwiZmlsZSI6ImNyZWF0ZS10ZWFtLWRpYWxvZy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJ0bi1vdXRsaW5lLXByaW1hcnkge1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICNkYmM3MDA7XG4gICAgY29sb3I6IGJsYWNrO1xuICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xufVxuXG4uYnRuLW91dGxpbmUtcHJpbWFyeTpob3Zlcixcbi5idG4tb3V0bGluZS1wcmltYXJ5OmFjdGl2ZSB7XG4gICAgYmFja2dyb3VuZDogI2RiYzcwMDtcbiAgICBjb2xvcjogd2hpdGU7XG59XG5cbi5oZWFkZXItY29udGVudCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2Vlbjtcbn1cblxubGFiZWwge1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xufVxuXG4uY2xvc2Uge1xufVxuXG5cbi5yZXF1aXJlLWxhYmVsOmFmdGVyIHtcbiAgICBjb250ZW50OiAnIConO1xuICAgIGNvbG9yOiByZWQ7XG59XG5cbi5jb250ZW50LWhlYWRlciB7XG4gICAgZm9udC1zdHlsZTogbm9ybWFsO1xuICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgZm9udC1zaXplOiAxLjJyZW07XG4gICAgbGluZS1oZWlnaHQ6IDI3cHg7XG4gICAgcGFkZGluZzogMTlweCAwcHggMTRweCAwcHg7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/team/components/create-team-dialog/create-team-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;AACA;;;AAGA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA,o4CAAo4C","sourcesContent":[".btn-outline-primary {\n    border: 1px solid #dbc700;\n    color: black;\n    background: transparent;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:active {\n    background: #dbc700;\n    color: white;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\nlabel {\n    font-weight: bold;\n}\n\n.close {\n}\n\n\n.require-label:after {\n    content: ' *';\n    color: red;\n}\n\n.content-header {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1.2rem;\n    line-height: 27px;\n    padding: 19px 0px 14px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
